export const DOWNLOAL_APP_LINK =
  'https://delivers.dtignite.com/v2/delivers/clickAd.jsp?siteId=12467&campaignId=46138&tsti=true&updateApp=false&enablePostInstallAutoLaunch=true&dvURL=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.fotoscapes';
